/* Puuki.fi - puuki-product-options SUBMIT GUARD (v1, 2026-06-27)
   Estaa keskeneraisen personoinnin paatymisen ostoskoriin (vrt. tilaus #1377).
   Lomakkeen submitissa (CAPTURE-vaihe, ennen Dawnin product-formia):
     1) RE-DERIVE  - lukee kentat nakyvasta UI:sta ja kirjoittaa properties[...]
     2) RECONCILE  - disabloi tyhjat; ei laheta fonttia yksin ilman tekstia
     3) VALIDATE   - estaa lisayksen jos pakollinen, nakyva kentta on tyhja
   Itsenainen + idempotentti; toimii nykyisen asetin rinnalla; kattaa kaikki PO-tuotteet. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    var cs = document.querySelectorAll('.po[data-po-config]');
    for (var i = 0; i < cs.length; i++) attach(cs[i]);
  });

  function attach(po) {
    if (po._poGuard) return;
    po._poGuard = true;
    var form = po.closest('form');
    if (!form) return;
    var config;
    try { config = JSON.parse(po.getAttribute('data-po-config')); }
    catch (e) { return; }
    if (!config || !config.fields) return;

    ['input', 'change', 'click'].forEach(function (eventName) {
      po.addEventListener(eventName, function (event) {
        var field = event.target.closest('.po__field');
        if (field) clearFieldError(field);
        var summary = po.querySelector('.po__error');
        if (summary) summary.style.display = 'none';
      });
    });
    form.addEventListener('submit', function (e) {
      reconcile(po, config);
      var missing = validate(po, config);
      if (missing) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(po, missing);
      }
    }, true);
  }

  function propInput(po, name, fieldId) {
    // A hidden sibling can use the same property name: resolve the owning field.
    var wrap = po.querySelector('[data-po-field="' + cssEsc(fieldId) + '"]');
    return wrap ? wrap.querySelector('input[name="properties[' + cssEsc(name) + ']"]') : null;
  }
  function cssEsc(s) { return String(s).replace(/(["\\])/g, '\\$1'); }

  function isVisible(el) {
    while (el && el.nodeType === 1) {
      if (getComputedStyle(el).display === 'none') return false;
      el = el.parentElement;
    }
    return true;
  }

  function reconcile(po, config) {
    config.fields.forEach(function (f) {
      var wrap = po.querySelector('[data-po-field="' + f.id + '"]');
      var visible = wrap ? isVisible(wrap) : true;

      if (f.propertyName && f.type !== 'file_upload') {
        var inp = propInput(po, f.propertyName, f.id);
        if (inp) {
          var val = deriveValue(po, f);
          if (val != null) inp.value = val;
          inp.disabled = !inp.value || String(inp.value).trim() === '' || !visible;
        }
      }

      if (f.type === 'file_upload' && wrap) {
        wrap.querySelectorAll('input[type=file]').forEach(function (file) {
          file.disabled = !visible;
        });
      }

      if (f.fontPropertyName) {
        var fontInp = propInput(po, f.fontPropertyName, f.id);
        if (fontInp) {
          var fontVal = deriveFont(po, f);
          fontInp.value = fontVal || '';
          var textInp = f.propertyName ? propInput(po, f.propertyName, f.id) : null;
          var textOk = !!(textInp && textInp.value && String(textInp.value).trim() !== '' && !textInp.disabled);
          fontInp.disabled = !fontInp.value || !textOk || !visible;
        }
      }
    });
  }

  function deriveValue(po, f) {
    var wrap = po.querySelector('[data-po-field="' + f.id + '"]');
    if (!wrap) return null;
    switch (f.type) {
      case 'radio_color':
      case 'radio_image':
      case 'radio_button': {
        var a = wrap.querySelector('.po__swatch--active, .po__radio-btn--active');
        return a ? a.getAttribute('data-po-value') : null;
      }
      case 'text':
      case 'textarea':
      case 'select': {
        var el = wrap.querySelector('[data-po-input="' + f.id + '"]');
        return el ? el.value : null;
      }
      case 'toggle': {
        var cb = wrap.querySelector('.po__toggle-input');
        return cb && cb.checked ? 'Kyllä' : '';
      }
      case 'personalized_text': {
        var lines = wrap.querySelectorAll('.po__pt-line');
        var parts = [];
        for (var i = 0; i < lines.length; i++) {
          if (getComputedStyle(lines[i]).display === 'none') continue;
          var t = lines[i].querySelector('.po__pt-input');
          if (t && t.value && t.value.trim() !== '') parts.push(t.value);
        }
        return parts.join(' | ');
      }
    }
    return null;
  }

  function deriveFont(po, f) {
    var wrap = po.querySelector('[data-po-field="' + f.id + '"]');
    if (!wrap) return null;
    var a = wrap.querySelector('.po__font-btn--active .po__font-name');
    return a ? (a.textContent || '').trim() : null;
  }

  function clearFieldError(wrap) {
    wrap.classList.remove('po__field--error');
    wrap.querySelectorAll('[aria-invalid="true"]').forEach(function (el) {
      el.removeAttribute('aria-invalid');
      el.removeAttribute('aria-errormessage');
    });
    var error = wrap.querySelector('[data-po-field-error]');
    if (error) error.remove();
  }

  function validate(po, config) {
    var first = null;
    config.fields.forEach(function (f) {
      var wrap = po.querySelector('[data-po-field="' + f.id + '"]');
      if (!wrap) return;
      clearFieldError(wrap);
      if (!isVisible(wrap)) return;
      var text = deriveValue(po, f);
      var missingFont = f.type === 'personalized_text' && !!String(text || '').trim() && !deriveFont(po, f);
      wrap._poMissingFont = missingFont;
      if (!f.required && !missingFont) return;
      var ok;
      if (f.type === 'file_upload') {
        var fi = wrap.querySelector('input[type=file]');
        ok = !!(fi && fi.files && fi.files.length > 0);
      } else if (f.propertyName) {
        var inp = propInput(po, f.propertyName, f.id);
        ok = !!(inp && inp.value && String(inp.value).trim() !== '' && !inp.disabled);
      } else {
        ok = true;
      }
      if (!ok || missingFont) {
        wrap.classList.add('po__field--error');
        var message = document.createElement('p');
        message.className = 'po__help';
        message.dataset.poFieldError = '';
        message.id = 'PuukiError-' + Array.from(document.querySelectorAll('.po')).indexOf(po) + '-' + f.id;
        message.textContent = missingFont ? 'Valitse tekstille fontti.' : (f.type === 'file_upload' ? 'Liitä tiedosto tai valitse toinen toimitustapa.' : 'Täytä tai valitse: ' + (f.label || f.propertyName || 'pakollinen tieto') + '.');
        wrap.appendChild(message);
        var target = missingFont ? wrap.querySelector('[data-po-pt-font]') : wrap.querySelector('input:not([type="hidden"]), textarea, select, button');
        if (target) {
          target.setAttribute('aria-invalid', 'true');
          target.setAttribute('aria-errormessage', message.id);
        }
        if (!first) first = wrap;
      }
    });
    return first;
  }

  function showError(po, wrap) {
    var box = po.querySelector('.po__error');
    if (!box) {
      box = document.createElement('div');
      box.className = 'po__error';
      po.insertBefore(box, po.firstChild);
    }
    box.textContent = wrap && wrap._poMissingFont ? 'Valitse tekstille fontti ennen ostoskoriin lisäämistä.' : 'Täytä kaikki pakolliset kentät ennen ostoskoriin lisäämistä.';
    box.setAttribute('role', 'alert');
    box.style.display = '';
    var target = wrap && (wrap._poMissingFont ? wrap.querySelector('[data-po-pt-font]') : wrap.querySelector('input:not([type="hidden"]), textarea, select, button'));
    if (target) target.focus({ preventScroll: true });
    if (wrap && wrap.scrollIntoView) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
})();
